<template>
  <a-drawer
    :destroy-on-close="true"
    :title="isUpdate ? '端口映射编辑' : '端口映射创建'"
    :visible="visible"
    :width="800"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="云服务器" prop="host">
        <simple-select
          v-model="form.host"
          :options="hostOptions"
          :autoSelect="false"
          :showSearch="true"
          :filterOption="filterOption"
          style="width: 100%"
        ></simple-select>
      </a-form-model-item>
      <a-form-model-item label="本地端口" prop="localPort">
        <a-input v-model="form.localPort" type="number" min="1"></a-input>
      </a-form-model-item>
      <a-form-model-item label="协议" prop="protocol">
        <a-input v-model="form.protocol" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="公网 IP 地址" prop="publicIp">
        <simple-select
          v-model="form.publicIp"
          :options="publicIpOptions"
          :autoSelect="false"
          :showSearch="true"
          :filterOption="filterOption"
          style="width: 100%"
        ></simple-select>
      </a-form-model-item>
      <a-form-model-item label="映射端口" prop="mapPort">
        <a-input v-model="form.mapPort" type="number" min="1"></a-input>
      </a-form-model-item>

      <a-form-model-item label="应用场景" prop="applicationScenario">
        <a-input v-model="form.applicationScenario" type="textarea" :max-length="150"></a-input>
      </a-form-model-item>
      <a-form-model-item label="开通时间" prop="openTime">
        <a-date-picker v-model="form.openTime" type="date"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="关闭时间" prop="closeTime">
        <a-date-picker v-model="form.closeTime" type="date"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark"  type="textarea" :max-length="200"></a-input>
      </a-form-model-item>

      <a-form-model-item
        :wrapper-col="{ span: 20, offset: 4 }"
        style="margin-bottom: 0"
      >
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  getHostInventoryList,
  getPublicIpInventoryList,
  getPortMapInventory,
  updatePortMapInventory,
  createPortMapInventory
} from '@/api/inventory.js'
import SimpleSelect from '@/components/select/SimpleSelect.vue'
import moment from 'moment'

export default {
  name: 'InputDrawer',
  components: {
    SimpleSelect
  },
  // 应用场景（文本框形式，150字限制）、开通时间（日期类型）、关闭时间（日期类型）、备注（文本框形式多少字限制？）
  data () {
    return {
      visible: false,
      isUpdate: false,
      form: {
        id: '',
        host: undefined,
        localPort: '',
        protocol: '',
        publicIp: undefined,
        mapPort: '',
        applicationScenario: '',
        openTime: '',
        closeTime: '',
        remark: ''
      },
      rules: {
        host: [
          {
            message: '请选择云服务器',
            required: true,
            trigger: 'select'
          }
        ],
        localPort: [
          {
            message: '请输入本地端口',
            required: true,
            trigger: 'blur'
          }
        ],
        publicIp: [
          {
            message: '请选择公网 IP 地址',
            required: true,
            trigger: 'select'
          }
        ],
        mapPort: [
          {
            message: '请输入映射端口',
            required: true,
            trigger: 'blur'
          }
        ],
        applicationScenario: [
          {
            message: '请输入应用场景',
            required: true,
            trigger: 'blur'
          },
          {
            max: 150,
            message: '应用场景不能超过150个字符',
            trigger: 'blur'
          }
        ],
        openTime: [
          {
            message: '请选择开通时间',
            required: true,
            trigger: 'blur'
          }
        ],    
        closeTime: [
          {
            message: '请选择关闭时间',
            required: true,
            trigger: 'blur'
          }
        ],  
        remark: [
          {
            message: '请输入备注',
            required: true,
            trigger: 'blur'
          },
          {
            max: 200,
            message: '备注不能超过200个字符',
            trigger: 'blur'
          }
        ]
       
      },
      loading: false,
      hostOptions: [],
      publicIpOptions: [],
      filterOption: (input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  },
  methods: {
    show (id) {
      this.fetchHostList()
      this.fetchPublicIpList()
      if (id) {
        this.isUpdate = true
        getPortMapInventory(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              host: data.host ? { label: data.host.name, value: data.host.id } : undefined,
              localPort: data.local_port,
              protocol: data.protocol,
              mapPort: data.map_port,
              publicIp: data.public_ip ? { label: data.public_ip.ip_address, value: data.public_ip.id } : undefined,
              applicationScenario: data.application_scenario,
              openTime: data.open_time ? moment(data.open_time) : null,
              closeTime: data.close_time ? moment(data.close_time) : null,
              remark: data.remark
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer () {
      this.form = {
        id: '',
        host: undefined,
        localPort: '',
        protocol: '',
        publicIp: undefined,
        mapPort: '',
        applicationScenario: '',
        openTime: null,
        closeTime: null,
        remark: ''
      }
      this.publicIpOptions = []
      this.hostOptions = []
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            host_id: this.form.host ? this.form.host.value : undefined,
            local_port: this.form.localPort,
            public_ip_id: this.form.publicIp ? this.form.publicIp.value : undefined,
            map_port: this.form.mapPort,
            application_scenario: this.form.applicationScenario,
            open_time: this.form.openTime ? moment(this.form.openTime).format('YYYY-MM-DD') : null,
            close_time: this.form.closeTime ? moment(this.form.closeTime).format('YYYY-MM-DD') : null,
            remark: this.form.remark
          }
          if (this.form.protocol) params.protocol = this.form.protocol
          if (this.isUpdate) {
            updatePortMapInventory(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createPortMapInventory(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    },
    fetchHostList () {
      getHostInventoryList().then(res => {
        if (res.data && res.data.total) {
          this.hostOptions = res.data.data.map(item => {
            return {
              label: item.private_ip,
              value: item.id
            }
          })
        }
      })
    },
    fetchPublicIpList () {
      getPublicIpInventoryList().then(res => {
        if (res.data && res.data.total) {
          this.publicIpOptions = res.data.data.map(item => {
            return {
              label: item.ip_address,
              value: item.id
            }
          })
        }
      })
    }
  }
}
</script>
